import axios from 'axios';
import { AUTH_ENDPOINT } from '../api/api';

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGING_FAIL = 'LOGING_FAIL';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';


export const login = (user) => ({
  type: LOGIN_SUCCESS,
  user
});

export const loginFail = (errMessage) => ({
  type: LOGING_FAIL,
  errMessage
});

export const startLogin = (email, password) => {
  return async (dispatch) => {
    try {
      let user = await axios.post(`${AUTH_ENDPOINT}/sign_in`, {
        email,
        password
      });
      const {
        "access-token": accessToken,
        client,
        uid
      } = user.headers;
      const { role, name } = user.data.data;
      await sessionStorage.setItem('user', JSON.stringify({
        "access-token": accessToken,
        client,
        uid,
        role,
        name
      }));
      user = JSON.parse(sessionStorage.user);
      return dispatch(login(user));
    } catch (err) {
      if (err.response && err.response.status === 401) {
        return dispatch(loginFail({ errMessage: err.response.data.errors[0] }));
      }
      return dispatch(loginFail({ errMessage: 'Please check your connection and try again' }));
    }
  };
};


export const startLogout = () => {
  return async (dispatch) => {
    try {

      let signOut = await axios({
        url: `${AUTH_ENDPOINT}/sign_out`,
        method: 'delete',
        headers: JSON.parse(sessionStorage.user)
      });
      sessionStorage.removeItem('user');
      return dispatch(logout());
    } catch (err) {
      return new Error(
        err.response.data.errors[0]
      );
    }
  };
};

export const logout = () => ({
  type: LOGOUT_SUCCESS
});

export const startValidation = (history) => {
  return async (dispatch) => {
    try {
      await axios({
        url: `${AUTH_ENDPOINT}/validate_token`,
        method: 'get',
        headers: JSON.parse(sessionStorage.user)
      });
      const user = JSON.parse(sessionStorage.user);
      return user;
    } catch (err) {
      return false;
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/authActions.js